import React, {Component} from 'react'

export class SelectAlternateLeader extends Component{
    constructor(props){
        super(props)
        this.state = {
            defaultRutLeader: ""
        }
        this.onSelectAlternateLeader = (evt) => {
            let newValue = evt.target.value
            this.setState({
                defaultRutLeader: newValue
            }, () => this.addAlternateLeader())
        }
        this.addAlternateLeader = () => {
            let defaultRutLeader = this.state.defaultRutLeader
            this.props.addAlternateLeader(defaultRutLeader)
            this.setState({defaultRutLeader: ""})
        }
    }

    render(){
        const {alternateLeaders} = this.props
        return(
            <div>
                <SelectGeneric
                    defaultValue = {this.state.defaultRutLeader}
                    options = {alternateLeaders}
                    action = {this.onSelectAlternateLeader}
                    title = "Líderes Suplentes"
                />
            </div>
        )
    }
}
const SelectGeneric = ({defaultValue, options, action, title}) => {
    return(
        <div>
            <label className="control-label">{title}</label>
            <select className="form-control"
                    value={defaultValue}
                    onChange={action}
            >
                <option key={0} value="">Seleccionar</option>
                {options.map((option, index)=>{
                    return <option key={index} value={option.usuarioRUN}>{`${option.nombreCorto} - Ruta (${option.numberRegion})`}</option>
                })}
            </select>
        </div>
    )
}


// WEBPACK FOOTER //
// ./frontEnd/nominas/nominaIG/components/SelectAlternateLeader.jsx